import { render, staticRenderFns } from "./DocumentsNew.vue?vue&type=template&id=0fca67bb&scoped=true"
import script from "./DocumentsNew.vue?vue&type=script&lang=js"
export * from "./DocumentsNew.vue?vue&type=script&lang=js"
import style0 from "./DocumentsNew.vue?vue&type=style&index=0&id=0fca67bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca67bb",
  null
  
)

export default component.exports